import React, { useEffect } from 'react';
import Loader from 'cccisd-loader';

import { CV_URL } from '../Welcome';

const ImmediateCvRedirect = () => {
    useEffect(() => {
        window.location.href = CV_URL;
    }, []);

    return (
        <div className="pt-5">
            <Loader type="inline" loading />;
        </div>
    );
};

export default ImmediateCvRedirect;
